import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';

import { ConfigViewPillar, flatten } from './config.insight.model';
import {
    CustomizePillarsInsightCanSelectFn,
    CustomizePillarsInsightChangeEvent,
} from './customize-pillars.insight.model';
import {
    NestedNode,
    NestedNodeSelectInsightChangeEvent,
} from './nested-node-select.insight.model';

function mapToNode(pillar: ConfigViewPillar): NestedNode {
    return {
        id: pillar.identifier,
        label: pillar.name,
        children: pillar?.pillars?.map?.(mapToNode),
    };
}

function mapToPillar(
    node: NestedNode,
    lookup: ConfigViewPillar[],
): ConfigViewPillar {
    return lookup.find((e) => e.identifier === node.id);
}

@Component({
    selector: 'customize-pillars-insight',
    templateUrl: './customize-pillars.insight.component.html',
})
export class CustomizePillarsInsightComponent
    implements OnChanges, OnInit, OnDestroy
{
    @Input() pillars: ConfigViewPillar[];
    @Input() selection: ConfigViewPillar[];
    @Input() canSelect: CustomizePillarsInsightCanSelectFn;
    @Output() change: EventEmitter<CustomizePillarsInsightChangeEvent>;

    _canSelect: any;

    localState: {
        pillarsFlatten: ConfigViewPillar[];
        nodes: NestedNode[];
        selection: NestedNode[];
    };

    constructor() {
        this.change = new EventEmitter();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.pillars != null ||
            changes.selection != null ||
            changes.canSelect != null
        ) {
            this._setValues();
        }
    }

    ngOnInit(): void {
        this._setValues();
    }

    ngOnDestroy(): void {
        this.change.complete();
    }

    _onChange(event: NestedNodeSelectInsightChangeEvent): void {
        this.change?.emit({
            selected: event.selected.map((ee) =>
                mapToPillar(ee, this.localState.pillarsFlatten),
            ),
        });
    }

    private _setValues(): void {
        const pillarsFlatten = flatten(
            this.pillars,
            (i) => i,
            (i) => i.pillars,
        );
        const nodes = this.pillars.map(mapToNode);
        const selection = this.selection.map(mapToNode);
        this.localState = { pillarsFlatten, nodes, selection };
        this._canSelect = (node, checked) =>
            this.canSelect?.(
                mapToPillar(node, this.localState.pillarsFlatten),
                checked,
            ) ?? true;
    }
}
